module.exports = __webpack_public_path__ + "img/pr-16.930d2788.png";